import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from './auth.service';

@Injectable()
export class AuthExpiryInterceptor implements HttpInterceptor {
  private readonly sessionReasonCodes = new Set([
    'AUTH_REQUIRED',
    'AUTH_TOKEN_INVALID',
    'AUTH_TOKEN_EXPIRED',
    'AUTH_TOKEN_REVOKED',
  ]);

  constructor(private authService: AuthService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (this.isExpiredSessionError(error)) {
          void this.authService.handleSessionExpired();
        }
        return throwError(() => error);
      })
    );
  }

  private isExpiredSessionError(error: HttpErrorResponse): boolean {
    if (error.status !== 401) {
      return false;
    }

    const payload = error?.error?.error || error?.error || {};
    const code = String(payload?.code || '').toUpperCase();
    const reasonCode = String(payload?.reasonCode || '').toUpperCase();
    const message = String(payload?.message || error?.message || '').toLowerCase();

    if (this.sessionReasonCodes.has(reasonCode)) {
      return true;
    }

    if (code !== 'UNAUTHORIZED') {
      return false;
    }

    return (
      message.includes('authentication required') ||
      message.includes('invalid authentication token') ||
      message.includes('token expired') ||
      message.includes('token revoked') ||
      message.includes('not authenticated')
    );
  }
}
